import { render, staticRenderFns } from "./component-button.vue?vue&type=template&id=ddae22c8&scoped=true&lang=pug"
import script from "./component-button.vue?vue&type=script&lang=coffee"
export * from "./component-button.vue?vue&type=script&lang=coffee"
import style0 from "./component-button.vue?vue&type=style&index=0&id=ddae22c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddae22c8",
  null
  
)

export default component.exports